var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-ideas"},[_c('div',{staticClass:"top-white-box"}),_vm._m(0),_c('Articles')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-gray-box"},[_c('h1',[_vm._v("The Best Gift Buying Ideas")])])
}]

export { render, staticRenderFns }